import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import FlatColorPickerProps from './FlatColorPickerProps'

import Messages from './Messages'

export default {
    props: FlatColorPickerProps,
    render (h) {
        return h('div')
    },
    mixins: [
        KendoBaseComponent,
        Messages
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoFlatColorPicker(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoFlatColorPicker()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoFlatColorPicker/KendoFlatColorPickerMixin.js